import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'
import {payOrder} from '@/api/server/pay'
import {warning, success} from '@/utils/message'
import VueQr from 'vue-qr';
import {orderPayStatus} from '@/api/server/order'

export default {
  name: 'PayPage',
  mixins: [commonMixin],
  data () {
    return {
      _orderSn: null,
      qrcode: null,
      orderInfo: null,
      timer: null,
      payStatus: false
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    VueQr
  },
  methods: {
    onMyOrder () {
      this.$router.push({name: 'user-order'})
    },
    _getOrderPayStatus () {
      let query = {
        order_sn: this._orderSn
      }
      orderPayStatus(query).then( res => {
        console.log(res)
        if (res.code === 200 && res.data) {
          let status = res.data.status
          if (status === 1) {
            this.payStatus = true
            success('支付成功')
            clearInterval(this.timer)
            this.$router.push({name: 'user-order'});
          }
        }
      })
    },
    getOrder () {
      let query = {
        order_sn: this._orderSn
      }
      payOrder(query).then( (res) => {
        if (res.code === 200 && res.data) {
          if (res.data.order) {
            this.orderInfo = res.data.order
          }
          if (res.data.qrcode) {
            if (res.data.qrcode.code_url) {
              this.qrcode = res.data.qrcode.code_url
            } else {
              this.qrcode = res.data.qrcode
            }
          }
        } else {
          warning(res.message)
          this.$router.push({name: 'user-order'});
        }
      })
    },
    reset () {
      this.qrcode = null
      this.orderInfo = null
      this.payStatus = false
      this.getOrder()
      this.timer = setInterval(() => {
        this._getOrderPayStatus()
      }, 2500);
    },
    handleRoute (route) {
        if (route.name === 'pay') {
          this._orderSn = this.$route.query.order_sn
          this.reset()
        }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  },
  created() {
  },
  beforeDestroy() {
    if (this.timer) {
        console.log("销毁定时器")
       clearInterval(this.timer)
    }
  }
}